import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const TestimonialsSection = () => {
  const { t } = useLanguage();
  return (
    <section className="section-padding bg-night text-white"><div className="container-custom"><h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">{t('testimonials.title')}</h2><p className="text-gray-400 text-lg">{t('testimonials.subtitle')}</p></div></section>
  );
};

export default TestimonialsSection;
